import styled from 'styled-components'
import Media from 'builder/styles/media'

export const Container = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  padding-top: 32px;
  width: calc(100% - 40px);
  gap: 64px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-bottom: 64px;

  ${Media.Tablet`
    gap: 48px;
    padding-top: 32px;
    width: calc(100% - 40px);
  `};

  ${Media.Phone`
    gap: 48px;
    width: calc(100% - 40px);
  `};
`
